import React from "react";
import { IoIosArrowDropright } from "react-icons/io";
import {
  AiOutlineCheck,
  AiOutlineClose,
  AiOutlineCloseCircle,
} from "react-icons/ai";

const ProgressBar = ({
  steps = [
    { label: "Basic Info", completed: true },
    { label: "Skills", completed: true },
    { label: "Previous Work", completed: true },
    { label: "Resume", completed: false },
  ],
  percentage = 66,
  buttonName = "Complete Profile",
  buttonAction = () => {
    alert("Complete Profile button clicked!");
  },
  description = "Complete your company profile to unlock full functionality and enhance your hiring potential.",
  closeIcon = (
    <AiOutlineClose className="text-white  text-xl rounded-full   cursor-pointer bg-primary" />
  ),
  onClose, // Optional close action passed as prop
}) => {
  return (
    <div className="bg-[#151515] p-6 rounded-xl flex justify-start items-center m-12 relative">
      {/* Close Icon positioned at the top left */}
      <div
        className="absolute     -top-2 -right-1 cursor-pointer"
        onClick={onClose} // Trigger the provided onClose function when clicked
      >
        {closeIcon}
      </div>

      {/* Circular Progress Bar */}
      <div className="relative w-16 h-16">
        <svg className="w-full h-full transform -rotate-90">
          <circle cx="32" cy="32" r="28" className="bg-gray-400" />
          <circle
            cx="32"
            cy="32"
            r="28"
            stroke="currentColor"
            strokeWidth="4"
            fill="transparent"
            className="text-orange-500"
            strokeDasharray="176"
            strokeDashoffset={176 - (percentage / 100) * 176}
          />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-white text-sm">
          {percentage}%
        </span>
      </div>

      {/* Progress Details */}
      <div className="flex-1 ml-8">
        <div className="flex w-full justify-between items-center mb-2">
          <p className="text-white text-base font-medium">{description}</p>
          <div className="w-68">
            <button
              className="flex items-center px-4 py-2 bg-orange-500 text-white rounded-lg"
              onClick={buttonAction}
            >
              {buttonName}
              <IoIosArrowDropright className="ml-2" />
            </button>
          </div>
        </div>

        {/* Progress Steps */}
        <div className="flex items-center w-[55%] mb-[2%]">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              {/* Step Circle */}
              <div
                className={`relative w-8 h-8 rounded-full ${
                  step.completed ? "bg-green-500" : "bg-white"
                } flex items-center justify-center`}
              >
                <span
                  className={`text-xs ${
                    step.completed ? "text-white" : "text-gray-400"
                  }`}
                >
                  <AiOutlineCheck />
                </span>
                <div className="absolute text-sm -bottom-5 flex justify-center items-start left-0.5 min-w-max text-white">
                  {step.label}
                </div>
              </div>

              {/* Connecting Line */}
              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-0.5 ${
                    steps[index].completed && steps[index + 1].completed
                      ? "bg-green-500"
                      : "bg-gray-400"
                  }`}
                ></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
